<nav
  *transloco="let t"
  class="pl-3 mb-3 navbar navbar-expand-md navbar-dark sticky-top justify-content-center bg-dark text-center">
  <div class="header-container w-100 d-md-none">
    <div
      class="d-flex w-100"
      tabindex="0"
      role="button"
      (click)="toggleMenu()"
      (keydown.enter)="toggleMenu()"
      (keydown.space)="toggleMenu()">
      <h1 class="m-auto navbar-brand" [innerText]="title"></h1>
    </div>
    <div
      class="header-arrow text-white"
      [ngClass]="{
        'header-arrow-up': !isMenuCollapsed(),
        'header-arrow-down': isMenuCollapsed(),
      }">
      ❯
    </div>
  </div>
  <div
    id="collapsibleNavbar"
    class="collapse navbar-collapse justify-content-between"
    [ngbCollapse]="isMenuCollapsed()">
    <ul class="navbar-nav mr-auto">
      @for (item of navItems; track item.id) {
        <li *appIfRole="item.role" class="nav-item">
          <a class="nav-link" routerLinkActive="active" [id]="item.id" [routerLink]="item.route" (click)="closeMenu()">
            {{ t(item.labelKey) }}
          </a>
        </li>
      }
    </ul>
    <ul class="navbar-nav gap-2">
      <li>
        <language-selector class="align-content-center" />
      </li>
      <li>
        <app-session-management class="align-content-center" />
      </li>
    </ul>
  </div>
</nav>
